import { useEffect, useRef, useState } from "react";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import { FormControl, Helper, InputSearch, Label, OptionsList, Select, SelectButton } from "./Style";
import Chevron from "./Chevron";
import OptionItem from "../../../models/OptionItem";
import SelectHelper from "../../../helpers/Selects/SelectHelper";
import TmpListItemCustom from "../TmpListItemCustom/TmpListItemCustom";

interface TmpInputSelectSearchCustomProps {
    id: string;
    label: string;
    name: string;
    placeholder: string;
    maxLength?: number;
    value: OptionItem;
    mandatory?: boolean;
    helperIcon?: "info" | "error";
    helperText?: string;
    itens: OptionItem[];
    error?: boolean;
    disabled?: boolean;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}


export default function TmpInputSelectSearchCustom(props: TmpInputSelectSearchCustomProps) {

    const [_inputOpened, setInputOpened] = useState(false);
    const [_value, setValue] = useState<OptionItem>(props.value);
    const ref = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;
    const [_textSearch, setTextSearch] = useState<string>("");
    const [_itensAux, setItensAux] = useState<OptionItem[]>([]);
    const [_itens, setItens] = useState<OptionItem[]>(props.itens);
    const [_indexSelected, setIndexSelected] = useState<number>(0);

    useEffect(() => {


        if (_itensAux === null || _itensAux?.length === 0) {
            setItensAux(props.itens);
            setItens(props.itens);
        }
        
        if (props.value) {
            let index = SelectHelper.GetIndex(props.value, props.itens);
            setIndexSelected(index);
            setValue(props.value);
            setTextSearch(props.value.Text);
        } else {
            setIndexSelected(0)
            setTextSearch("");
        }

    }, [props.itens, _itensAux, props.value]);

    const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setInputOpened(false);
        }
    };

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const _handleClick = () => {
        if (props.disabled) return;

        setTimeout(() => {
            if (!_inputOpened) {
                const itemIndex = SelectHelper.GetIndex(_value, props.itens);
                if (document !== null && itemIndex > 0) {
                    let item = document.getElementById(`${props.id}-${itemIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
            }
        }, 100);
        setInputOpened(!_inputOpened);
    };

    const _handleChange = (item: OptionItem) => {
        props.onChange(convertToDefEventPara(props.name, item))
        setValue(item);
        setTextSearch(item.Text);
        setItens(_itensAux);
    };

    const handleListItemKeyDown = (event: any, index: number) => {
        switch (event.key) {
            case "Tab":
                setInputOpened(false);
                break;

            case "ArrowUp":
                event.preventDefault();
                const prevIndex = index > 0 ? index - 1 : index;
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${prevIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            case "ArrowDown":
                event.preventDefault();
                const nextIndex = index < props.itens.length - 1 ? index + 1 : index;
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${nextIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            case "Enter":
                setInputOpened(false);
                _handleChange(props.itens[index]);
                if (document !== null) {
                    let item = document.getElementById(props.id);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            default:
                break;
        }
    };

    const handleInputChange = (e: any) => {
        setTextSearch(e.target.value);
        setInputOpened(true);
        setItens(SelectHelper.FilterOptions(e.target.value, _itensAux));

    };

    //OBS: Método usando apenas para renderizar a mensagem de erro ao passar pelo campo. A seleção do campo dispara o evento de OnChange (handleAutocompleteChange)
    const handleOnBlurChange = (newValue: any) => {
        if (props.onBlur && newValue.target.value === "") {
            props.onBlur(convertToDefEventPara(props.name, newValue.target.value))
            setValue(newValue.target.value)
        }
    };


    // Passing style props to styled component
    FormControl.defaultProps = style;
    Label.defaultProps = style;
    Select.defaultProps = style;
    SelectButton.defaultProps = style;
    OptionsList.defaultProps = style;
    Helper.defaultProps = style;

    return (
        <>
            <FormControl
                actived={_inputOpened}
                onClick={_handleClick}
                onBlur={handleOnBlurChange}
                error={props.error ? true : false}
                selected={true}
                disabled={props.disabled ? true : false}
            >
                <Label htmlFor={props.id} id={labelId} className="tmp-select__label">
                    {props.label}{props.mandatory ? " *" : ""}
                </Label>

                <Select data-testid="select" ref={ref}>
                    <SelectButton type="button" id={`${props.id}-button`}>
                        <InputSearch 
                            autoComplete="off"
                            onClick={_handleClick} 
                            onChange={handleInputChange} 
                            name={`input-${props.name}`} 
                            value={_textSearch} 
                            placeholder={props.placeholder} type="text" />
                        <TmpIconCustom size="sm" icon={<Chevron />} />
                    </SelectButton>

                    <OptionsList
                        id={props.id}
                        selected={_indexSelected}
                        actived={_inputOpened}
                        value={(_value !== undefined ? _value.Text : null)}
                        disabled={props.disabled ? true : false}
                        role="listbox"
                        aria-labelledby={labelId}
                    >
                        {_itens.map((item, index) => (
                            <TmpListItemCustom
                                id={`${props.id}-${index}`}
                                key={index}
                                label={item.Text}
                                role="option" 
                                tabIndex={index === 0 ? 0 : -1}
                                aria-selected={_indexSelected === index}
                                handleClick={() => _handleChange(item)}
                                keyDown={(e: any) => { handleListItemKeyDown(e, index); }}
                            />
                        ))}

                        {_itens.length === 0 &&
                            <TmpListItemCustom
                                id={`-1-not-fount-${props.id}`}
                                key={-1}
                                label={"Resultado não encontrado"}
                                role="option"
                            />
                        }
                    </OptionsList>
                </Select>

                <Helper >
                    {props.helperIcon === "error" && props.error &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconError />} />
                        </span>
                    }
                    {props.helperIcon === "info" &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconInfo />} />
                        </span>
                    }
                    {props.helperText}

                </Helper>
            </FormControl>
        </>
    );
}
